<template>
  <div>
    <el-dialog :visible.sync="diaShow" title="选择商品" width="900px" custom-class="dialog-body-paddingTop-10" @close="close">
      <div class="flex flex-align-center gap-10">
        <div class="flex flex-align-center">
          <div class="keyLabel">关键字：</div>
          <el-input v-model="keywords" style="width:200px" placeholder="商品名称、规格编码"></el-input>
        </div>
        <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
      </div>
      <el-table :data="tablelist" v-loading="tableloading" class="margin-top-20" max-height="500" ref="table" row-key="ProductId"
       @selection-change="selectionChange" v-if="diaShow">
        <el-table-column type="selection" width="55" reserve-selection></el-table-column>
        <el-table-column prop="" label="商品">
          <template slot-scope="scope">
            <div class="flex flex-align-center gap-10">
              <img :src="scope.row.ImgUrlComplete" style="width:60px;height:60px" alt="">
              <div class="ellipsis">
                {{scope.row.Name}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="规格">
          <template slot-scope="scope">
            <div class="ellipsis">
              {{scope.row.SpecValue||'默认规格'}}
              <span v-if="scope.row.SpecValue2">;{{scope.row.SpecValue2}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="规格编码">
          <template slot-scope="scope">
            <div class="ellipsis">
              {{scope.row.Barcode||'--'}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="flex flex-align-center flex-justify-between margin-top-10">
        <el-checkbox :value="allcheck" @change="checkAll">当前页全选</el-checkbox>
        <el-pagination v-if="Total" style="margin-top:10px" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="Total">
        </el-pagination>
      </div>
      <div class="flex flex-align-center flex-justify-center margin-top-10 gap-10">
        <span>已选中 <span class="color-f56c6c">{{checklist.length}}</span> 个</span>
        <el-button type="primary" @click="confirm">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import config from '@/config/index';
import {
  cittaDistributioncittaDistributionProductList
} from "@/api/sv3.0.0"
export default {
  props:{
    show:{
      type:Boolean,
      default:false,
    },
    data:{
      type:Array,
      default:()=>{
        return []
      }
    },
    Id:{
      type:Number,
      default:null,
    },
  },
  watch:{
    show(val){
      this.diaShow = val
      if(val){
        this.isFirst = true
        this.gettablelist()
        this.checklist = []
      }
    }
  },
  computed: {
    allcheck(){
      if(!this.tablelist.length) return false
      return this.tablelist.every(v=>{
        return this.checklist.some(x=>v.ProductId==x.ProductId)
      })
    }
  },
  data () {
    return {
      diaShow:false,
      keywords:'',
      tablelist:[],
      tableloading:false,
      Total:0,
      currentPage:1,
      pageSize:20,
      checklist:[],
      isFirst:false,
    }
  },
  methods: {
    confirm(){
      this.$emit('confirm',this.checklist)
    },
    selectionChange(e){
      this.checklist = e
    },
    checkAll(e){
      this.$refs.table.toggleAllSelection()
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pageSize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywords:this.keywords,
          CittaDistributionId:this.Id,
          Skip:(this.currentPage-1)*this.pageSize,
          Take:this.pageSize
        }
        let res = await cittaDistributioncittaDistributionProductList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.Total = res.Result.Total
          if(this.isFirst){
            this.$nextTick(()=>{
              this.data.forEach(x=>{
                this.$refs.table.toggleRowSelection(x)
              })
              this.gettablelist()
            })
            this.isFirst = false
          }
        }
      }finally{
        this.tableloading = false
      }
    },
    close(e){
      this.$emit('close',false)
    }
  }
}
</script>

<style lang='less' scoped>

.yellowBox{
	background: #FDF6EC;
	padding: 15px ;
	font-size: 14px;
	color: #FDA23C;
}
.file-box{
	border: 1px solid #DCDFE6;
	width: 500px;
	height: 172px;
	margin: 20px auto;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>